import styled from "styled-components";

export const ModifyBiometricDialogBox = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    ${({theme}) => theme.font.presets.body};

    svg {
        margin: 1rem 0;
    }
  
    padding: 0 2rem;

    width: 35vw;
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: auto;
    }
`;
